/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { UnitDependencies } from './dependenciesUnitClass.generated';
import { createInverseConductanceQuantum } from '../../factoriesAny.js';
export var inverseConductanceQuantumDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  UnitDependencies: UnitDependencies,
  createInverseConductanceQuantum: createInverseConductanceQuantum
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesInverseConductanceQuantum.generated.js
// module id = 1431
// module chunks = 0